import * as angular from "angular";
import userEntities from "../../user-entities/user-entities";
import template from "./user-modal-entities-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";

export interface UserModalEntitiesTabController {
	user?: unknown;
	permissions?: unknown;
}

// eslint-disable-next-line no-redeclare
export class UserModalEntitiesTabController {
	public readonly tab: ModalTabItem = {
		name: "Entity Assignment",
		code: "ENTITY_ASSIGNMENT"
	};
}

export default angular
	.module("vesl.components.user-modal.tabs.entities", [userEntities])
	.component("userModalEntitiesTab", {
		controller: UserModalEntitiesTabController,
		template,
		bindings: {
			user: "<",
			permissions: "<"
		}
	})
	.name;
